
































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';

import '@/compiled-icons/polygon-segment';
import '@/compiled-icons/circle-segment';
import '@/compiled-icons/square-segment';
import AmetrasTimeFieldTemplate from '@/fields/time/AmetrasTimeFieldTemplate.vue';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';

/**
 * General Component for Fields of type BREAK_TIMES_LIST
 */
@Component({
  mixins: [BindAttrs],
  components: {
    AmetrasTimeFieldTemplate,
  }
})
export default class AmetrasMachineWorkingAreaBoundaryTemplate extends Vue {
  @Prop() value!: DisguiseDto.BreakTimeDto[] | null | undefined;
  @Prop() label!: string;
  @Prop() readonly!: boolean;
  internalValue: DisguiseDto.BreakTimeDto[] = [];

  @Watch('value') valueChanged(newValue: DisguiseDto.BreakTimeDto[] | null | undefined) {
    if (newValue !== undefined && newValue !== null) {
      this.internalValue = newValue;
    }
  }

  created() {
    if (this.value !== undefined && this.value !== null) {
      this.internalValue = this.value;
    }
  }

  addBreak() {
    const newValue = this.internalValue;
    newValue.push({
      from: '',
      to: ''
    });
    this.$emit('change', newValue);

    this.$nextTick(() => {
      this.$nextTick(() => {
        let lastBreakFromField = this.$refs['breakFromField-' + (this.internalValue.length - 1)];
        if (lastBreakFromField) {
          if (Array.isArray(lastBreakFromField)) {
            lastBreakFromField = lastBreakFromField[0];
          }
          const lastBreakFromFieldEl = (lastBreakFromField as Vue).$el;
          HTML_SERVICE_INSTANCE.focusFirstNode(lastBreakFromFieldEl);
        }
      });
    });
  }

  removeBreak(
      breakIdx: number
  ) {
    if (this.internalValue) {
      this.internalValue.splice(breakIdx, 1);
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    }
  }

}
